import { render, staticRenderFns } from "./complaint-table.vue?vue&type=template&id=4964a13e&scoped=true"
import script from "./complaint-table.vue?vue&type=script&lang=js"
export * from "./complaint-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4964a13e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4964a13e')) {
      api.createRecord('4964a13e', component.options)
    } else {
      api.reload('4964a13e', component.options)
    }
    module.hot.accept("./complaint-table.vue?vue&type=template&id=4964a13e&scoped=true", function () {
      api.rerender('4964a13e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-analysis/driver-data/normal/components/complaint-table.vue"
export default component.exports